/**
 * resourceReservedInstanceApprovalRecord模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const resourceReservedInstanceApprovalRecord = {
  // 上级节点内容
  listApprovalRecord(params) {
    return $http.post(`${global.API_URL}/sme/resourceReservedInstanceApprovalRecord/listApprovalRecord`,params);
  }
}

export default resourceReservedInstanceApprovalRecord;



// WEBPACK FOOTER //
// ./src/api/resourceReservedInstanceApprovalRecord.js